import React from "react";

export enum CalendarIconType {
  PROGRESS_PHOTO_CIRCLE,
  PROGRESS_PHOTO_RECT,
  PROGRESS_PHOTO,
  WORKOUT_CIRCLE,
  WORKOUT_RECT,
  CARDIO_CIRCLE,
  CARDIO_RECT,
  IMPORTED_CARDIO_RECT,
  BODY_STAT_CIRCLE,
  BODY_STAT_RECT,
  BODY_WEIGHT,
  BODY_FAT,
  WAIST,
  NUTRITION,
  STEPS_HABIT_LARGE,
  STEPS_HABIT_SMALL,
  HABIT_CIRCLE,
  HABIT_RECT,
}
interface Props {
  type: CalendarIconType;
  width?: number;
  height?: number;
}

const CalendarIcons = (props: Props) => {
  const { type, width, height } = props;

  if (type === CalendarIconType.STEPS_HABIT_SMALL) {
    return (
      <svg
        width={width || 24}
        height={height || 24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="8" fill="#FFCC32" />
        <g clipPath="url(#clip1)">
          <path
            d="M5.68552 11.733C5.93054 11.1659 6.12419 10.7181 6.10197 10.0172C6.0914 9.68463 6.22908 9.36751 6.47977 9.14715C6.73344 8.92434 7.07033 8.82747 7.40401 8.88141C7.75414 8.93812 8.10501 8.96921 8.43987 8.97946C8.3605 8.36711 8.67891 7.75519 9.25484 7.47929L9.95114 7.14572C10.0541 7.09637 10.173 7.09221 10.2793 7.13429C10.3854 7.17627 10.4693 7.26065 10.5106 7.36714C10.5106 7.36714 11.3984 9.6653 12.9237 11.1859C14.0099 12.1011 15.1283 12.626 15.9924 12.626C16.7517 12.626 17.4899 12.8598 18.0707 13.2845C18.661 13.7159 18.9995 14.2831 18.9995 14.8406C18.9995 14.8509 19 16.4635 19 16.4635C19 16.69 18.8164 16.8737 18.5898 16.8737H5.41016C5.18361 16.8737 5 16.69 5 16.4635V14.9117C5 13.3189 5.38004 12.4395 5.68552 11.733ZM7.27295 9.69125C7.18205 9.67651 7.0903 9.70279 7.02141 9.76335C6.98264 9.79742 6.91812 9.8724 6.92186 9.99118C6.94995 10.8754 6.70151 11.45 6.43843 12.0584C6.16521 12.6905 5.88376 13.3423 5.82971 14.5014H15.5822V13.4197C15.2512 13.378 14.9247 13.2886 14.6107 13.17L14.2827 13.8838C14.2136 14.0342 14.0651 14.1229 13.9098 14.1229C13.8524 14.1229 13.7942 14.1108 13.7388 14.0853C13.533 13.9907 13.4427 13.7472 13.5373 13.5413L13.8656 12.8269C13.6419 12.706 13.4301 12.5762 13.2344 12.4454L12.6926 13.1611C12.6119 13.2676 12.4893 13.3238 12.3652 13.3238C12.279 13.3238 12.192 13.2967 12.118 13.2406C11.9374 13.1039 11.9017 12.8467 12.0385 12.6661L12.5733 11.9596C12.5101 11.9089 12.2447 11.6845 12.1714 11.6191L11.3901 12.3803C11.3103 12.458 11.207 12.4968 11.1039 12.4968C10.9971 12.4968 10.8904 12.4553 10.81 12.3728C10.6519 12.2105 10.6553 11.9508 10.8176 11.7928L11.5818 11.0483C11.4751 10.9359 11.3733 10.8233 11.2771 10.7111L10.1049 11.2784C10.0474 11.3062 9.9865 11.3194 9.92657 11.3194C9.77426 11.3194 9.62793 11.2341 9.55711 11.0878C9.45842 10.8839 9.54366 10.6386 9.74756 10.54L10.7687 10.0458C10.6592 9.88148 10.5655 9.72191 10.4899 9.57002C9.56577 9.88586 8.13332 9.83043 7.27295 9.69125ZM9.90628 8.0768L9.60934 8.21907C9.33035 8.35269 9.19022 8.66672 9.27139 8.9613C9.63722 8.93257 9.95381 8.87703 10.1886 8.80354L9.90628 8.0768ZM17.5867 13.9467C17.2548 13.7042 16.8381 13.5408 16.4026 13.4769V14.5014H18.087C17.9882 14.3088 17.8143 14.1131 17.5867 13.9467ZM5.82031 16.0533H18.1797V15.3217H5.82031V16.0533Z"
            fill="white"
          />
          <path
            d="M9.24805 12.6378C9.24805 13.3432 8.67415 13.9171 7.96866 13.9171C7.26328 13.9171 6.68938 13.3432 6.68938 12.6378C6.68938 11.9324 7.26328 11.3586 7.96866 11.3586C8.67415 11.3586 9.24805 11.9324 9.24805 12.6378ZM7.96866 12.179C7.71562 12.179 7.50969 12.3848 7.50969 12.6378C7.50969 12.891 7.71562 13.0968 7.96866 13.0968C8.2218 13.0968 8.42763 12.8909 8.42763 12.6378C8.42763 12.3848 8.2218 12.179 7.96866 12.179Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip1">
            <rect
              width="14"
              height="14"
              fill="white"
              transform="matrix(-1 0 0 1 19 5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (type === CalendarIconType.STEPS_HABIT_LARGE) {
    return (
      <svg
        width={width || 64}
        height={height || 64}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="64" height="64" rx="8" fill="#FFCC32" />
        <g clipPath="url(#clip2)">
          <path
            d="M15.7628 31.3133C16.3928 29.8551 16.8908 28.7038 16.8336 26.9015C16.8065 26.0462 17.1605 25.2307 17.8051 24.6641C18.4574 24.0912 19.3237 23.8421 20.1817 23.9808C21.0821 24.1266 21.9843 24.2065 22.8454 24.2329C22.6413 22.6583 23.4601 21.0848 24.941 20.3753L26.7315 19.5176C26.9963 19.3907 27.302 19.38 27.5753 19.4882C27.8483 19.5961 28.0639 19.8131 28.1702 20.0869C28.1702 20.0869 30.4531 25.9965 34.3752 29.9065C37.1682 32.2601 40.0442 33.6097 42.2662 33.6097C44.2187 33.6097 46.1169 34.211 47.6105 35.303C49.1282 36.4123 49.9986 37.8708 49.9986 39.3045C49.9986 39.3309 50 43.4776 50 43.4776C50 44.0599 49.5279 44.5323 48.9453 44.5323H15.0547C14.4721 44.5323 14 44.0599 14 43.4776V39.4871C14 35.3914 14.9772 33.1302 15.7628 31.3133ZM19.8447 26.0632C19.611 26.0253 19.3751 26.0929 19.1979 26.2486C19.0982 26.3362 18.9323 26.529 18.9419 26.8345C19.0142 29.1081 18.3753 30.5857 17.6988 32.1502C16.9962 33.7756 16.2725 35.4516 16.1335 38.4322H41.2115V35.6507C40.3603 35.5433 39.5207 35.3134 38.7132 35.0086L37.8697 36.8441C37.692 37.2308 37.3102 37.4588 36.9109 37.4588C36.7634 37.4588 36.6137 37.4277 36.4712 37.3621C35.9419 37.119 35.7098 36.4928 35.9532 35.9633L36.7972 34.1264C36.222 33.8154 35.6774 33.4817 35.1742 33.1453L33.7809 34.9858C33.5735 35.2596 33.2582 35.4041 32.9391 35.4041C32.7174 35.4041 32.4938 35.3343 32.3035 35.1901C31.8391 34.8385 31.7473 34.1772 32.0989 33.7127L33.4741 31.8961C33.3118 31.7657 32.6292 31.1886 32.4408 31.0205L30.4317 32.978C30.2265 33.1777 29.9609 33.2774 29.6956 33.2774C29.4212 33.2774 29.1469 33.1708 28.94 32.9585C28.5335 32.5413 28.5423 31.8736 28.9595 31.4671L30.9247 29.5527C30.6503 29.2638 30.3886 28.9743 30.1411 28.6857L27.127 30.1444C26.979 30.216 26.8224 30.2498 26.6683 30.2498C26.2767 30.2498 25.9004 30.0307 25.7183 29.6544C25.4645 29.1301 25.6837 28.4992 26.208 28.2457L28.8337 26.9748C28.5522 26.5524 28.3113 26.142 28.1169 25.7515C25.7405 26.5636 22.0571 26.4211 19.8447 26.0632ZM26.6161 21.9118L25.8526 22.2776C25.1352 22.6212 24.7748 23.4287 24.9836 24.1862C25.9243 24.1123 26.7384 23.9695 27.3421 23.7805L26.6161 21.9118ZM46.3657 37.0059C45.5124 36.3821 44.4409 35.9622 43.3209 35.7977V38.4322H47.6522C47.3982 37.937 46.951 37.4338 46.3657 37.0059ZM16.1094 42.4227H47.8906V40.5415H16.1094V42.4227Z"
            fill="white"
          />
          <path
            d="M24.9231 33.6399C24.9231 35.4537 23.4474 36.9295 21.6332 36.9295C19.8194 36.9295 18.3437 35.4537 18.3437 33.6399C18.3437 31.826 19.8194 30.3506 21.6332 30.3506C23.4474 30.3506 24.9231 31.826 24.9231 33.6399ZM21.6332 32.46C20.9826 32.46 20.453 32.9892 20.453 33.6399C20.453 34.2908 20.9826 34.8201 21.6332 34.8201C22.2842 34.8201 22.8134 34.2906 22.8134 33.6399C22.8134 32.9892 22.2842 32.46 21.6332 32.46Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip2">
            <rect
              width="36"
              height="36"
              fill="white"
              transform="matrix(-1 0 0 1 50 14)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (type === CalendarIconType.HABIT_CIRCLE) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#E8EAEE" />
        <path
          d="M16 7.61803L17.6574 12.7188C17.7912 13.1309 18.1752 13.4098 18.6084 13.4098H23.9717L19.6327 16.5623C19.2822 16.8169 19.1356 17.2683 19.2694 17.6803L20.9268 22.7812L16.5878 19.6287C16.2373 19.374 15.7627 19.374 15.4122 19.6287L11.0732 22.7812L12.7306 17.6803C12.8644 17.2683 12.7178 16.8169 12.3673 16.5623L12.0734 16.9668L12.3673 16.5623L8.02828 13.4098H13.3916C13.8248 13.4098 14.2088 13.1309 14.3426 12.7188L16 7.61803Z"
          stroke="#01052F"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.HABIT_RECT) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="8" fill="#FFCC32" />
        <path
          d="M8.24877 17.1631L9.4571 13.4443C9.59098 13.0322 9.44432 12.5809 9.09383 12.3262L5.93039 10.0279L9.84062 10.0279C10.2738 10.0279 10.6578 9.7489 10.7917 9.33688L12 5.61803L13.2083 9.33688C13.3422 9.7489 13.7262 10.0279 14.1594 10.0279H18.0696L14.9062 12.3262C14.5557 12.5809 14.409 13.0323 14.5429 13.4443L15.7512 17.1631L12.5878 14.8647C12.2373 14.6101 11.7627 14.6101 11.4122 14.8647L8.24877 17.1631ZM8.24877 17.1631L7.77325 17.0086L8.24877 17.1631L8.54267 17.5676L8.24877 17.1631Z"
          stroke="white"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.BODY_STAT_CIRCLE) {
    return (
      <svg
        style={{ display: "block" }}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#E8EAEE" />
        <path
          d="M22.5938 8H9.40625C8.63084 8 8 8.63084 8 9.40625V22.5938C8 23.3692 8.63084 24 9.40625 24H22.5938C23.3692 24 24 23.3692 24 22.5938V9.40625C24 8.63084 23.3692 8 22.5938 8ZM23.0625 22.5938C23.0625 22.8522 22.8522 23.0625 22.5938 23.0625H9.40625C9.14778 23.0625 8.9375 22.8522 8.9375 22.5938V9.40625C8.9375 9.14778 9.14778 8.9375 9.40625 8.9375H22.5938C22.8522 8.9375 23.0625 9.14778 23.0625 9.40625V22.5938Z"
          fill="#01052F"
        />
        <path
          d="M20.3232 11.0438L19.5637 10.6641C18.463 10.1137 17.2307 9.82281 16 9.82281C14.7693 9.82281 13.537 10.1137 12.4363 10.6641L11.6767 11.0438L11.9122 11.7501H9.875V22.1251H22.125V11.7501H20.0878L20.3232 11.0438ZM12.8555 11.5026C14.8245 10.5181 17.1755 10.5181 19.1445 11.5026L19.1768 11.5188L18.5142 13.5064C17.8481 13.3109 17.1604 13.1953 16.4688 13.1593V11.7501H15.5312V13.1593C14.8396 13.1953 14.1519 13.3109 13.4858 13.5063L12.8232 11.5188L12.8555 11.5026ZM21.1875 12.6876V21.1876H16.4688V15.519H15.5312V21.1876H10.8125V12.6876H12.2247L12.8911 14.6868L13.4801 14.4904C15.1051 13.9488 16.8949 13.9488 18.5199 14.4904L19.109 14.6868L19.7753 12.6876H21.1875Z"
          fill="#01052F"
        />
        <path
          d="M14.5938 15.5312H11.7812V16.4688H14.5938V15.5312Z"
          fill="#01052F"
        />
        <path
          d="M14.5938 17.4062H11.7812V18.3438H14.5938V17.4062Z"
          fill="#01052F"
        />
        <path
          d="M14.5938 19.2812H11.7812V20.2188H14.5938V19.2812Z"
          fill="#01052F"
        />
        <path
          d="M20.2188 15.5312H17.4062V16.4688H20.2188V15.5312Z"
          fill="#01052F"
        />
        <path
          d="M20.2188 17.4062H17.4062V18.3438H20.2188V17.4062Z"
          fill="#01052F"
        />
        <path
          d="M20.2188 19.2812H17.4062V20.2188H20.2188V19.2812Z"
          fill="#01052F"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.BODY_STAT_RECT) {
    return (
      <svg
        style={{ display: "block" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="#5B64A0" />
        <path
          d="M18.5938 4H5.40625C4.63084 4 4 4.63084 4 5.40625V18.5938C4 19.3692 4.63084 20 5.40625 20H18.5938C19.3692 20 20 19.3692 20 18.5938V5.40625C20 4.63084 19.3692 4 18.5938 4ZM19.0625 18.5938C19.0625 18.8522 18.8522 19.0625 18.5938 19.0625H5.40625C5.14778 19.0625 4.9375 18.8522 4.9375 18.5938V5.40625C4.9375 5.14778 5.14778 4.9375 5.40625 4.9375H18.5938C18.8522 4.9375 19.0625 5.14778 19.0625 5.40625V18.5938Z"
          fill="white"
        />
        <path
          d="M16.3232 7.04379L15.5637 6.66404C14.463 6.11366 13.2307 5.82275 12 5.82275C10.7693 5.82275 9.53703 6.11366 8.43628 6.66404L7.67675 7.04379L7.91216 7.75H5.875V18.125H18.125V7.75H16.0878L16.3232 7.04379ZM8.85553 7.50257C10.8245 6.51807 13.1755 6.51807 15.1445 7.50257L15.1768 7.51872L14.5142 9.50632C13.8481 9.31085 13.1604 9.19519 12.4688 9.15922V7.75H11.5312V9.15919C10.8396 9.19519 10.1519 9.31085 9.48578 9.50628L8.82325 7.51869L8.85553 7.50257ZM17.1875 8.6875V17.1875H12.4688V11.5189H11.5312V17.1875H6.8125V8.6875H8.22466L8.89106 10.6867L9.48009 10.4903C11.1051 9.94869 12.8949 9.94869 14.5199 10.4903L15.109 10.6867L15.7753 8.6875H17.1875Z"
          fill="white"
        />
        <path
          d="M10.5938 11.5312H7.78125V12.4688H10.5938V11.5312Z"
          fill="white"
        />
        <path
          d="M10.5938 13.4062H7.78125V14.3438H10.5938V13.4062Z"
          fill="white"
        />
        <path
          d="M10.5938 15.2812H7.78125V16.2188H10.5938V15.2812Z"
          fill="white"
        />
        <path
          d="M16.2188 11.5312H13.4062V12.4688H16.2188V11.5312Z"
          fill="white"
        />
        <path
          d="M16.2188 13.4062H13.4062V14.3438H16.2188V13.4062Z"
          fill="white"
        />
        <path
          d="M16.2188 15.2812H13.4062V16.2188H16.2188V15.2812Z"
          fill="white"
        />
      </svg>
    );
  }

  if (type === CalendarIconType.BODY_WEIGHT) {
    return (
      <svg
        style={{ display: "block" }}
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z"
          fill="white"
        />
        <path
          d="M32.8359 0H3.16406C1.4194 0 0 1.4194 0 3.16406V32.8359C0 34.5806 1.4194 36 3.16406 36H32.8359C34.5806 36 36 34.5806 36 32.8359V3.16406C36 1.4194 34.5806 0 32.8359 0ZM33.8906 32.8359C33.8906 33.4175 33.4175 33.8906 32.8359 33.8906H3.16406C2.58251 33.8906 2.10938 33.4175 2.10938 32.8359V3.16406C2.10938 2.58251 2.58251 2.10938 3.16406 2.10938H32.8359C33.4175 2.10938 33.8906 2.58251 33.8906 3.16406V32.8359Z"
          fill="#000632"
        />
        <path
          d="M27.7273 6.84864L26.0184 5.9942C23.5417 4.75586 20.769 4.10132 18 4.10132C15.231 4.10132 12.4583 4.75586 9.98163 5.9942L8.27269 6.84864L8.80235 8.43763H4.21875V31.7814H31.7812V8.43763H27.1976L27.7273 6.84864ZM10.9249 7.8809C15.3551 5.66577 20.6449 5.66577 25.0751 7.8809L25.1477 7.91725L23.657 12.3893C22.1583 11.9495 20.611 11.6893 19.0547 11.6084V8.43763H16.9453V11.6083C15.389 11.6893 13.8417 11.9495 12.343 12.3893L10.8523 7.91718L10.9249 7.8809ZM29.6719 10.547V29.672H19.0547V16.9177H16.9453V29.672H6.32812V10.547H9.50548L11.0049 15.0452L12.3302 14.6034C15.9865 13.3847 20.0136 13.3847 23.6699 14.6034L24.9952 15.0452L26.4945 10.547H29.6719Z"
          fill="#000632"
        />
        <path
          d="M14.8359 16.9453H8.50781V19.0547H14.8359V16.9453Z"
          fill="#000632"
        />
        <path
          d="M14.8359 21.1641H8.50781V23.2734H14.8359V21.1641Z"
          fill="#000632"
        />
        <path
          d="M14.8359 25.3828H8.50781V27.4922H14.8359V25.3828Z"
          fill="#000632"
        />
        <path
          d="M27.4922 16.9453H21.1641V19.0547H27.4922V16.9453Z"
          fill="#000632"
        />
        <path
          d="M27.4922 21.1641H21.1641V23.2734H27.4922V21.1641Z"
          fill="#000632"
        />
        <path
          d="M27.4922 25.3828H21.1641V27.4922H27.4922V25.3828Z"
          fill="#000632"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.WAIST) {
    return (
      <svg
        style={{ display: "block" }}
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.55028 5.40001C3.15028 6.84001 1.50028 11.7 1.35028 13.95C-0.449725 24.75 7.20028 29.25 9.90028 30.6C12.0603 31.68 27.6003 31.05 35.1003 30.6V22.5H22.0503V20.7V12.15C22.0503 9.45001 15.3003 3.60001 8.55028 5.40001Z"
          fill="white"
        />
        <path
          d="M14.7656 12.7266H8.4375V14.8359H14.7656V12.7266Z"
          fill="#000632"
        />
        <path
          d="M11.6016 19.0547C15.5898 19.0547 18.9844 16.8133 18.9844 13.7812C18.9844 10.7484 15.5887 8.50781 11.6016 8.50781C7.6133 8.50781 4.21875 10.7492 4.21875 13.7812C4.21875 16.8141 7.61442 19.0547 11.6016 19.0547ZM11.6016 10.6172C14.46 10.6172 16.875 12.0661 16.875 13.7812C16.875 15.4964 14.46 16.9453 11.6016 16.9453C8.74308 16.9453 6.32812 15.4964 6.32812 13.7812C6.32812 12.0661 8.74308 10.6172 11.6016 10.6172Z"
          fill="#000632"
        />
        <path
          d="M23.2031 21.1641V13.7812C23.2031 8.45852 18.1071 4.28906 11.6016 4.28906C5.09604 4.28906 0 8.45852 0 13.7812V20.1094C0 26.5065 5.20446 31.7109 11.6016 31.7109H36V21.1641H23.2031ZM21.0938 21.1641H18.9728C19.7793 20.6278 20.4932 20.0035 21.0938 19.3068V21.1641ZM11.6016 6.39844C16.9243 6.39844 21.0938 9.64139 21.0938 13.7812C21.0938 17.9211 16.9243 21.1641 11.6016 21.1641C6.27884 21.1641 2.10938 17.9211 2.10938 13.7812C2.10938 9.64139 6.27884 6.39844 11.6016 6.39844ZM10.5469 29.5426V27.4922H8.4375V29.0586C4.75453 27.7526 2.10938 24.2344 2.10938 20.1094V19.3068C4.19231 21.7233 7.63488 23.2734 11.6016 23.2734H25.3125V29.6016H23.2031V25.3828H21.0938V29.6016H18.9844V27.4922H16.875V29.6016H14.7656V25.3828H12.6562V29.6016H11.6016C11.2451 29.6016 10.8933 29.5811 10.5469 29.5426ZM33.8906 29.6016H27.4219V23.2734H33.8906V29.6016Z"
          fill="#000632"
        />
        <path
          d="M31.7109 25.3828H29.6016V27.4922H31.7109V25.3828Z"
          fill="#000632"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.BODY_FAT) {
    return (
      <svg
        style={{ display: "block" }}
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.3502 2.70001C19.3502 3.60001 20.2504 4.05001 18.4504 7.20001C17.4827 8.89347 19.3502 14.4 19.3502 18.45C21.6002 20.25 22.3671 21.6216 23.4004 22.95C23.4004 22.95 19.8002 23.85 16.6502 23.85C13.5002 23.85 9.4502 22.95 9.4502 22.95C9.67846 22.7218 11.2502 18.9 13.0502 14.85C14.0479 11.0241 14.6014 7.35375 14.4002 6.75001C13.9502 5.40001 13.9502 4.50001 13.5002 3.60001C13.0502 2.70001 15.3002 0.450012 16.2002 0.450012C17.1002 0.450012 19.3502 1.80001 19.3502 2.70001Z"
          fill="white"
        />
        <path
          d="M28.4189 17.033H23.7271V16.3473C23.7271 15.9686 23.427 15.6616 23.0568 15.6616H20.5677C19.6354 13.1049 19.1023 10.2164 19.1023 7.4564V5.65025C19.1023 5.64945 19.1023 5.64864 19.1023 5.64811C19.5228 5.0749 19.7726 4.36321 19.7726 3.59312C19.7726 1.7026 18.2692 0.16457 16.4213 0.16457C14.5734 0.16457 13.07 1.7026 13.07 3.59312C13.07 4.36347 13.3198 5.0749 13.7405 5.64811C13.7405 5.64891 13.7403 5.64945 13.7403 5.65025V7.4564C13.7403 11.8208 12.4105 16.5099 10.2704 19.6936C8.45361 22.396 7.47336 26.434 7.47336 28.8615C7.47336 30.3918 8.14964 31.8133 9.05187 33.0993C9.04977 33.1379 9.04846 33.1767 9.04846 33.2158C9.04846 34.3502 9.95043 35.2729 11.0592 35.2729C12.168 35.2729 13.07 34.3502 13.07 33.2158C13.07 32.0814 12.168 31.1587 11.0592 31.1587C10.5503 31.1587 10.0853 31.3534 9.73077 31.6735C9.18435 30.7697 8.81388 29.8221 8.81388 28.8615C8.81388 26.6094 9.77187 22.8551 11.3747 20.471C11.807 19.8278 12.2068 19.1354 12.5715 18.4045H13.003C13.3724 18.4045 13.6732 18.0967 13.6732 17.7187C13.6732 17.4051 13.4654 17.1402 13.1836 17.059C14.3959 14.141 15.0808 10.7575 15.0808 7.4564V6.73453C15.4916 6.91881 15.9448 7.02167 16.4213 7.02167C16.8978 7.02167 17.351 6.91881 17.7618 6.73453V7.4564C17.7618 10.2429 18.2509 13.087 19.1322 15.6616H19.0353C18.6651 15.6616 18.365 15.9686 18.365 16.3473V17.033C17.9956 17.033 17.6948 17.3408 17.6948 17.7187C17.6948 18.0967 17.9956 18.4045 18.365 18.4045V19.0902C18.365 19.4689 18.6651 19.7759 19.0353 19.7759H21.0264C21.1694 20.0132 21.3163 20.2454 21.4678 20.471C23.071 22.8551 24.0287 26.6094 24.0287 28.8615C24.0287 29.8218 23.6582 30.7695 23.1115 31.6732C22.757 31.3534 22.2921 31.1587 21.7833 31.1587C20.6745 31.1587 19.7726 32.0814 19.7726 33.2158C19.7726 34.3502 20.6745 35.2729 21.7833 35.2729C22.8921 35.2729 23.7941 34.3502 23.7941 33.2158C23.7941 33.177 23.7928 33.1381 23.7907 33.0998C24.6932 31.8133 25.3692 30.3915 25.3692 28.8615C25.3692 26.4581 24.4078 22.4772 22.6259 19.7759H23.0568C23.427 19.7759 23.7271 19.4689 23.7271 19.0902V18.4045H28.4189C28.7891 18.4045 29.0891 18.0975 29.0891 17.7187C29.0891 17.34 28.7891 17.033 28.4189 17.033ZM11.0592 32.5301C11.4289 32.5301 11.7295 32.8376 11.7295 33.2158C11.7295 33.594 11.4289 33.9015 11.0592 33.9015C10.6895 33.9015 10.389 33.594 10.389 33.2158C10.389 32.8376 10.6895 32.5301 11.0592 32.5301ZM16.4213 5.65025C15.3125 5.65025 14.4105 4.72749 14.4105 3.59312C14.4105 2.45875 15.3125 1.53599 16.4213 1.53599C17.5301 1.53599 18.4321 2.45875 18.4321 3.59312C18.4321 4.72749 17.5301 5.65025 16.4213 5.65025ZM21.7833 33.9015C21.4137 33.9015 21.1131 33.594 21.1131 33.2158C21.1131 32.8376 21.4137 32.5301 21.7833 32.5301C22.153 32.5301 22.4536 32.8376 22.4536 33.2158C22.4536 33.594 22.153 33.9015 21.7833 33.9015ZM22.3866 18.4045H19.7055V17.033H22.3866V18.4045Z"
          fill="#000632"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.4678 20.471C21.3163 20.2454 21.1694 20.0132 21.0264 19.7759H19.0353C18.6651 19.7759 18.365 19.4689 18.365 19.0902V18.4045C17.9956 18.4045 17.6948 18.0967 17.6948 17.7187C17.6948 17.3408 17.9956 17.033 18.365 17.033V16.3473C18.365 15.9935 18.6269 15.7024 18.9631 15.6655C18.9868 15.663 19.0109 15.6616 19.0353 15.6616H19.1322C19.1134 15.6069 19.0949 15.552 19.0765 15.497C18.2303 12.9661 17.7618 10.1837 17.7618 7.4564V6.73453C17.7089 6.75827 17.6552 6.78067 17.6009 6.80166C17.2338 6.94361 16.8364 7.02167 16.4213 7.02167C16.0062 7.02167 15.6087 6.94361 15.2416 6.80166C15.1873 6.78067 15.1337 6.75828 15.0808 6.73453V7.4564C15.0808 10.7001 14.4195 14.0234 13.2464 16.9064C13.2256 16.9574 13.2047 17.0083 13.1836 17.059C13.236 17.0741 13.2857 17.0955 13.3321 17.1224C13.5354 17.2403 13.6732 17.4633 13.6732 17.7187C13.6732 18.0967 13.3724 18.4045 13.003 18.4045H12.5715C12.2068 19.1354 11.807 19.8278 11.3747 20.471C9.77187 22.8551 8.81388 26.6094 8.81388 28.8615C8.81388 29.7716 9.14644 30.6701 9.64612 31.5307C9.67383 31.5784 9.70206 31.626 9.73077 31.6735C9.7713 31.6369 9.81327 31.6019 9.8566 31.5687C10.1922 31.3114 10.6085 31.1587 11.0592 31.1587C12.168 31.1587 13.07 32.0814 13.07 33.2158C13.07 34.3502 12.168 35.2729 11.0592 35.2729C9.95043 35.2729 9.04846 34.3502 9.04846 33.2158C9.04846 33.1767 9.04977 33.1379 9.05187 33.0993C8.14964 31.8133 7.47336 30.3918 7.47336 28.8615C7.47336 26.434 8.45361 22.396 10.2704 19.6936C12.4105 16.5099 13.7403 11.8208 13.7403 7.4564V5.65025C13.7403 5.64985 13.7403 5.64951 13.7404 5.64918C13.7405 5.64885 13.7405 5.64851 13.7405 5.64811C13.3198 5.0749 13.07 4.36347 13.07 3.59312C13.07 1.7026 14.5734 0.16457 16.4213 0.16457C18.2692 0.16457 19.7726 1.7026 19.7726 3.59312C19.7726 4.36321 19.5228 5.0749 19.1023 5.64811V7.4564C19.1023 10.2164 19.6354 13.1049 20.5677 15.6616H23.0568C23.427 15.6616 23.7271 15.9686 23.7271 16.3473V17.033H28.4189C28.7891 17.033 29.0891 17.34 29.0891 17.7187C29.0891 18.0975 28.7891 18.4045 28.4189 18.4045H23.7271V19.0902C23.7271 19.4689 23.427 19.7759 23.0568 19.7759H22.6259C22.6617 19.8302 22.6972 19.8851 22.7324 19.9404C24.4461 22.6367 25.3692 26.5064 25.3692 28.8615C25.3692 30.3915 24.6932 31.8133 23.7907 33.0998C23.7928 33.1381 23.7941 33.177 23.7941 33.2158C23.7941 34.3502 22.8921 35.2729 21.7833 35.2729C20.6745 35.2729 19.7726 34.3502 19.7726 33.2158C19.7726 32.0814 20.6745 31.1587 21.7833 31.1587C22.2339 31.1587 22.6501 31.3114 22.9857 31.5685C23.029 31.6017 23.071 31.6366 23.1115 31.6732C23.1403 31.6257 23.1685 31.5781 23.1962 31.5304C23.6961 30.6699 24.0287 29.7714 24.0287 28.8615C24.0287 26.6094 23.071 22.8551 21.4678 20.471ZM23.0692 31.4269C23.5545 30.5866 23.8678 29.7242 23.8678 28.8615C23.8678 27.7556 23.632 26.2702 23.1952 24.7625C22.7585 23.2551 22.1244 21.7378 21.3353 20.5642C21.1988 20.3611 21.0661 20.1527 20.9369 19.9404H19.0353C18.5762 19.9404 18.2042 19.5598 18.2042 19.0902V18.553C17.8226 18.4762 17.5339 18.1313 17.5339 17.7187C17.5339 17.3062 17.8226 16.9613 18.2042 16.8845V16.3473C18.2042 15.9214 18.5103 15.5686 18.9097 15.5067C18.0671 12.9707 17.6009 10.1866 17.6009 7.4564V6.97702C17.232 7.11224 16.835 7.18624 16.4213 7.18624C16.0076 7.18624 15.6105 7.11224 15.2416 6.97702V7.4564C15.2416 10.7218 14.5761 14.0667 13.3948 16.9699C13.6555 17.1132 13.8341 17.3945 13.8341 17.7187C13.8341 18.1876 13.4612 18.569 13.003 18.569H12.6697C12.3143 19.2729 11.9261 19.9412 11.5073 20.5642C10.7183 21.7378 10.0842 23.2551 9.64746 24.7625C9.21062 26.2702 8.97474 27.7556 8.97474 28.8615C8.97474 29.7245 9.28806 30.5868 9.77313 31.4271C10.1332 31.1553 10.578 30.9941 11.0592 30.9941C12.2569 30.9941 13.2309 31.9905 13.2309 33.2158C13.2309 34.4411 12.2569 35.4375 11.0592 35.4375C9.86159 35.4375 8.8876 34.4411 8.8876 33.2158C8.8876 33.1932 8.88801 33.1708 8.88871 33.1488C7.99391 31.8624 7.3125 30.4228 7.3125 28.8615C7.3125 26.4046 8.30057 22.3333 10.1378 19.6004C12.2572 16.4476 13.5794 11.792 13.5794 7.4564V5.70194C13.1582 5.10928 12.9091 4.38045 12.9091 3.59312C12.9091 1.61171 14.4845 0 16.4213 0C18.358 0 19.9334 1.61171 19.9334 3.59312C19.9334 4.38035 19.6843 5.10955 19.2632 5.70229V7.4564C19.2632 10.1575 19.7778 12.9846 20.6797 15.497H23.0568C23.5159 15.497 23.8879 15.8777 23.8879 16.3473V16.8685H28.4189C28.8779 16.8685 29.25 17.2491 29.25 17.7187C29.25 18.1884 28.8779 18.569 28.4189 18.569H23.8879V19.0902C23.8879 19.5598 23.5159 19.9404 23.0568 19.9404H22.9238C24.6198 22.6614 25.5301 26.5038 25.5301 28.8615C25.5301 30.4225 24.8489 31.8624 23.9539 33.1493C23.9546 33.1712 23.955 33.1934 23.955 33.2158C23.955 34.4411 22.981 35.4375 21.7833 35.4375C20.5857 35.4375 19.6117 34.4411 19.6117 33.2158C19.6117 31.9905 20.5857 30.9941 21.7833 30.9941C22.2643 30.9941 22.7092 31.1553 23.0692 31.4269ZM13.5817 5.622C13.5819 5.62101 13.582 5.62016 13.5822 5.61946L13.5825 5.61761L13.5827 5.6169C13.5827 5.61648 13.5823 5.61842 13.5817 5.622ZM11.5686 33.2158C11.5686 32.9285 11.3401 32.6947 11.0592 32.6947C10.7784 32.6947 10.5498 32.9285 10.5498 33.2158C10.5498 33.5031 10.7784 33.7369 11.0592 33.7369C11.3401 33.7369 11.5686 33.5031 11.5686 33.2158ZM14.5714 3.59312C14.5714 4.6366 15.4013 5.48568 16.4213 5.48568C17.4412 5.48568 18.2712 4.6366 18.2712 3.59312C18.2712 2.54964 17.4412 1.70056 16.4213 1.70056C15.4013 1.70056 14.5714 2.54964 14.5714 3.59312ZM21.2739 33.2158C21.2739 33.5031 21.5025 33.7369 21.7833 33.7369C22.0642 33.7369 22.2927 33.5031 22.2927 33.2158C22.2927 32.9285 22.0642 32.6947 21.7833 32.6947C21.5025 32.6947 21.2739 32.9285 21.2739 33.2158ZM19.8664 18.2399H22.2257V17.1976H19.8664V18.2399ZM11.7295 33.2158C11.7295 32.8376 11.4289 32.5301 11.0592 32.5301C10.6895 32.5301 10.389 32.8376 10.389 33.2158C10.389 33.594 10.6895 33.9015 11.0592 33.9015C11.4289 33.9015 11.7295 33.594 11.7295 33.2158ZM14.4105 3.59312C14.4105 4.72749 15.3125 5.65025 16.4213 5.65025C17.5301 5.65025 18.4321 4.72749 18.4321 3.59312C18.4321 2.45875 17.5301 1.53599 16.4213 1.53599C15.3125 1.53599 14.4105 2.45875 14.4105 3.59312ZM21.1131 33.2158C21.1131 33.594 21.4137 33.9015 21.7833 33.9015C22.153 33.9015 22.4536 33.594 22.4536 33.2158C22.4536 32.8376 22.153 32.5301 21.7833 32.5301C21.4137 32.5301 21.1131 32.8376 21.1131 33.2158ZM22.3866 18.4045V17.033H19.7055V18.4045H22.3866Z"
          fill="#000632"
        />
        <path
          d="M16.0312 16.875C15.5662 16.875 15.1875 17.2537 15.1875 17.7188C15.1875 18.1838 15.5662 18.5625 16.0312 18.5625C16.4963 18.5625 16.875 18.1838 16.875 17.7188C16.875 17.2537 16.4963 16.875 16.0312 16.875Z"
          fill="#01052F"
        />
      </svg>
    );
  }

  if (type === CalendarIconType.CARDIO_CIRCLE) {
    return (
      <svg
        style={{ display: "block" }}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#DADCE3" />
        <path
          d="M24 16.3955H22.2061C22.7378 15.5943 23.0312 14.7702 23.0312 13.831C23.0312 11.8701 21.7057 10.2291 19.9913 9.89387C18.2908 9.56143 16.8639 10.5794 16 12.0988C15.1362 10.5793 13.713 9.56984 12.0203 9.90081C10.3078 10.2357 8.96875 11.8772 8.96875 13.831C8.96875 14.7702 9.26219 15.5943 9.79391 16.3955H8V17.333H10.5259C11.3927 18.3059 12.5826 19.2985 13.9968 20.478C15.1304 21.4235 15.3518 21.6138 16 22.1689C16.6468 21.615 16.8698 21.4233 18.003 20.4782C19.4173 19.2986 20.6073 18.306 21.4741 17.333H24V16.3955ZM9.90625 13.831C9.90625 12.3707 10.8925 11.0766 12.2003 10.8209C13.7852 10.511 14.9524 11.8456 15.5658 13.3542L16 14.4221L16.4342 13.3541C17.1891 11.4977 18.4515 10.5481 19.8113 10.8139C21.1125 11.0684 22.0938 12.3654 22.0938 13.831C22.0938 14.6998 21.7673 15.4986 21.0405 16.3955H19.2718L17.8975 13.3415L16.625 16.3955H15.2804L14.7354 17.2131L13.1875 12.5695L11.9121 16.3955H10.9596C10.2327 15.4986 9.90625 14.6998 9.90625 13.831ZM17.4025 19.7583C16.9513 20.1345 16.4876 20.5214 16 20.9357C15.5124 20.5213 15.0485 20.1344 14.5973 19.7581C13.495 18.8387 12.5648 18.0627 11.8226 17.333H12.5878L13.1875 15.5341L14.4521 19.328L15.7821 17.333H17.25L17.9306 15.6996L18.6657 17.3267H20.1774C19.4352 18.0566 18.5049 18.8388 17.4025 19.7583Z"
          fill="#01052F"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.CARDIO_RECT) {
    return (
      <svg
        style={{ display: "block" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="#FF1400" />
        <path
          d="M20 12.3958H18.2061C18.7378 11.5946 19.0312 10.7704 19.0312 9.83124C19.0312 7.87033 17.7057 6.22933 15.9913 5.89411C14.2908 5.56168 12.8639 6.57968 12 8.09902C11.1362 6.57955 9.71303 5.57008 8.02034 5.90105C6.30781 6.2359 4.96875 7.87746 4.96875 9.83124C4.96875 10.7704 5.26219 11.5946 5.79391 12.3957H4V13.3332H6.52591C7.39266 14.3061 8.58262 15.2987 9.99681 16.4782C11.1304 17.4237 11.3518 17.6141 12 18.1691C12.6468 17.6153 12.8698 17.4236 14.003 16.4784C15.4173 15.2988 16.6073 14.3062 17.4741 13.3332H20V12.3958ZM5.90625 9.83124C5.90625 8.3709 6.89247 7.0768 8.20025 6.82111C9.78519 6.51124 10.9524 7.8458 11.5658 9.3544L12 10.4223L12.4342 9.35436C13.1891 7.49793 14.4515 6.54833 15.8113 6.81418C17.1125 7.06861 18.0938 8.36568 18.0938 9.83124C18.0938 10.7 17.7673 11.4988 17.0405 12.3957H15.2718L13.8975 9.34171L12.625 12.3958H11.2804L10.7354 13.2133L9.1875 8.56971L7.91213 12.3958H6.95956C6.23275 11.4988 5.90625 10.7 5.90625 9.83124ZM13.4025 15.7585C12.9513 16.1348 12.4876 16.5216 12 16.9359C11.5124 16.5216 11.0485 16.1346 10.5973 15.7583C9.495 14.8389 8.56478 14.063 7.82262 13.3332H8.58784L9.1875 11.5343L10.4521 15.3282L11.7821 13.3333H13.25L13.9306 11.6998L14.6657 13.327H16.1774C15.4352 14.0568 14.5049 14.8391 13.4025 15.7585Z"
          fill="white"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.IMPORTED_CARDIO_RECT) {
    return (
      <svg
        style={{ display: "block" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="#FF1400" />
        <path
          d="M15.1664 6.88891L14.214 4H9.78597L8.83359 6.88891C8.22894 7.04625 7.78125 7.59681 7.78125 8.25V15.75C7.78125 16.4032 8.22894 16.9537 8.83359 17.1111L9.78597 20H14.214L15.1664 17.1111C15.7711 16.9537 16.2188 16.4032 16.2188 15.75V8.25C16.2188 7.59681 15.7711 7.04625 15.1664 6.88891ZM13.536 4.9375L14.1644 6.84375H9.83559L10.464 4.9375H13.536ZM10.464 19.0625L9.83559 17.1562H14.1644L13.536 19.0625H10.464ZM15.2812 15.75C15.2812 16.0085 15.071 16.2188 14.8125 16.2188H9.1875C8.92903 16.2188 8.71875 16.0085 8.71875 15.75V8.25C8.71875 7.99153 8.92903 7.78125 9.1875 7.78125H14.8125C15.071 7.78125 15.2812 7.99153 15.2812 8.25V15.75Z"
          fill="white"
        />
        <path
          d="M13.4564 9.62703C12.9894 9.52978 12.4054 9.64193 11.9412 10.1529C11.4782 9.64412 10.896 9.53246 10.4304 9.62937C9.67628 9.7864 9.12891 10.4641 9.12891 11.2408C9.12891 12.3823 10.1853 13.012 11.9414 14.4169C13.6549 13.0461 14.7539 12.3942 14.7539 11.2408C14.7539 10.4623 14.2082 9.78356 13.4564 9.62703ZM11.9414 13.2186C10.7698 12.2982 10.0664 11.8018 10.0664 11.2408C10.0664 10.837 10.407 10.5343 10.7438 10.5343C11.0467 10.5343 11.3218 10.7737 11.5116 11.2099L11.9414 12.1973L12.3712 11.2099C12.5871 10.7139 12.9129 10.4714 13.2653 10.5448C13.5392 10.6018 13.8163 10.8592 13.8163 11.2408C13.8164 11.8012 13.1152 12.2967 11.9414 13.2186Z"
          fill="white"
        />
        <path
          d="M19.1538 8.42822L18.3164 8.84972C18.8114 9.8331 19.0624 10.8929 19.0624 11.9998C19.0624 13.1066 18.8114 14.1665 18.3164 15.1498L19.1538 15.5713C19.7152 14.456 19.9999 13.2544 19.9999 11.9998C19.9999 10.7452 19.7152 9.54353 19.1538 8.42822Z"
          fill="white"
        />
        <path
          d="M4.84606 8.42822C4.28466 9.54353 4 10.7452 4 11.9998C4 13.2544 4.28466 14.456 4.84606 15.5713L5.68347 15.1498C5.18847 14.1665 4.9375 13.1066 4.9375 11.9998C4.9375 10.8929 5.18847 9.8331 5.68347 8.84972L4.84606 8.42822Z"
          fill="white"
        />
        <path
          d="M17.0469 10.8023C17.1401 11.1925 17.1873 11.5956 17.1873 12.0004C17.1873 12.4053 17.1401 12.8083 17.0469 13.1986L17.9587 13.4163C18.069 12.9549 18.1248 12.4785 18.1248 12.0004C18.1248 11.5223 18.069 11.0459 17.9587 10.5845L17.0469 10.8023Z"
          fill="white"
        />
        <path
          d="M6.04109 10.5845C5.93088 11.0459 5.875 11.5223 5.875 12.0004C5.875 12.4785 5.93088 12.9549 6.04109 13.4163L6.95297 13.1986C6.85975 12.8083 6.8125 12.4053 6.8125 12.0004C6.8125 11.5956 6.85975 11.1925 6.95297 10.8023L6.04109 10.5845Z"
          fill="white"
        />
      </svg>
    );
  }

  if (type === CalendarIconType.PROGRESS_PHOTO_CIRCLE) {
    return (
      <svg
        style={{ display: "block" }}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#DADCE3" />
        <g clipPath="url(#clip0)">
          <path
            d="M16.0004 12.4998C13.7947 12.4998 12.0002 14.2943 12.0002 16.5C12.0002 18.7056 13.7948 20.5001 16.0004 20.5001C18.206 20.5001 20.0005 18.7056 20.0005 16.5C20.0005 14.2943 18.206 12.4998 16.0004 12.4998ZM16.0004 19.5C14.346 19.5 13.0003 18.1543 13.0003 16.5C13.0003 14.8456 14.346 13.4999 16.0004 13.4999C17.6547 13.4999 19.0005 14.8456 19.0005 16.5C19.0005 18.1543 17.6547 19.5 16.0004 19.5Z"
            fill="#01052F"
          />
          <path
            d="M23.9947 12.4973C23.9942 11.6714 23.3208 10.9992 22.4946 10.9992H20.3036L19.4413 9.27614C19.3563 9.10676 19.1834 8.99988 18.994 8.99988H12.9938C12.8043 8.99988 12.631 9.10676 12.5465 9.27614L11.6852 10.9997L9.49762 11.0026C8.6719 11.0041 8 11.6768 8 12.5022V21.5008C8 22.3277 8.67288 23.0003 9.50004 23.0003H22.5C23.3271 23.0003 24 22.3272 24 21.4998L23.9947 12.4973ZM22.5 22.0006H9.50008C9.2242 22.0006 9.00005 21.7766 9.00005 21.5008V12.5022C9.00005 12.2268 9.22417 12.0028 9.49909 12.0023L11.9953 11.9989C12.1847 11.9984 12.3576 11.8915 12.4421 11.7227L13.3029 9.99954H18.6849L19.5473 11.7226C19.6322 11.892 19.8051 11.9989 19.9946 11.9989H22.4946C22.7701 11.9989 23.0005 12.2229 23.0005 12.4982V21.5003C23.0005 21.7761 22.7759 22.0006 22.5 22.0006Z"
            fill="#01052F"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(8 8)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (type === CalendarIconType.PROGRESS_PHOTO_RECT) {
    return (
      <svg
        style={{ display: "block" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="#5B64A0" />
        <g clipPath="url(#clip0)">
          <path
            d="M12.0001 8.49968C9.79449 8.49968 8 10.2942 8 12.4998C8 14.7055 9.79452 16.5 12.0001 16.5C14.2058 16.5 16.0003 14.7055 16.0003 12.4998C16.0003 10.2942 14.2058 8.49968 12.0001 8.49968ZM12.0001 15.4999C10.3458 15.4999 9.00005 14.1542 9.00005 12.4998C9.00005 10.8455 10.3458 9.49973 12.0001 9.49973C13.6545 9.49973 15.0002 10.8455 15.0002 12.4998C15.0002 14.1542 13.6545 15.4999 12.0001 15.4999Z"
            fill="white"
          />
          <path
            d="M19.9947 8.49736C19.9942 7.67145 19.3208 6.99932 18.4946 6.99932H16.3036L15.4413 5.27624C15.3563 5.10685 15.1834 4.99997 14.994 4.99997H8.9938C8.80434 4.99997 8.63099 5.10685 8.54651 5.27624L7.68515 6.99981L5.49762 7.00273C4.6719 7.0042 4 7.67685 4 8.50228V17.5009C4 18.3278 4.67288 19.0004 5.50004 19.0004H18.5C19.3271 19.0004 20 18.3273 20 17.4999L19.9947 8.49736ZM18.5 18.0007H5.50008C5.2242 18.0007 5.00005 17.7766 5.00005 17.5009V8.50224C5.00005 8.22693 5.22417 8.00291 5.49909 8.00242L7.99526 7.99901C8.18472 7.99852 8.35758 7.89163 8.44205 7.72274L9.30292 5.99963H14.6849L15.5473 7.72271C15.6322 7.89209 15.8051 7.99898 15.9946 7.99898H18.4946C18.7701 7.99898 19.0005 8.22303 19.0005 8.49831V17.5004C19.0005 17.7762 18.7759 18.0007 18.5 18.0007Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (type === CalendarIconType.PROGRESS_PHOTO) {
    return (
      <svg
        style={{ display: "block" }}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.6663 25.3333C30.6663 26.8061 29.4724 28 27.9997 28H3.99967C2.52691 28 1.33301 26.8061 1.33301 25.3333V10.6667C1.33301 9.19391 2.52691 8 3.99967 8H9.33301L11.9997 4H19.9997L22.6663 8H27.9997C29.4724 8 30.6663 9.19391 30.6663 10.6667V25.3333Z"
          fill="white"
          stroke="#000632"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0003 22.6667C18.9458 22.6667 21.3337 20.2789 21.3337 17.3333C21.3337 14.3878 18.9458 12 16.0003 12C13.0548 12 10.667 14.3878 10.667 17.3333C10.667 20.2789 13.0548 22.6667 16.0003 22.6667Z"
          stroke="#000632"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === CalendarIconType.WORKOUT_RECT) {
    return (
      <svg
        style={{ display: "block" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="#FF1400" />
        <path
          d="M18.6712 7.31756L20 5.99175L18.0083 4L16.6824 5.32884L15.3566 4L14.0308 5.32884L12.705 4L10.7162 5.99175L13.3679 8.64341L8.63372 13.3775L5.98206 10.7259L4 12.7146L5.31916 14.0404L4 15.3663L5.31916 16.6921L4 18.0179L5.98206 20L7.30791 18.6808L8.63372 20L9.95953 18.6808L11.2854 20L13.2741 18.0179L10.6225 15.3663L15.3566 10.6321L18.0083 13.2838L20 11.2951L18.6712 9.96922L20 8.64341L18.6712 7.31756ZM18.0083 5.32884L18.6712 5.99175L18.0083 6.65466L17.3453 5.99175L18.0083 5.32884ZM14.6937 5.99175L15.3566 5.32884L18.6712 8.64341L18.0083 9.30631L14.6937 5.99175ZM5.98206 18.6808L5.31916 18.0179L5.98206 17.355L6.64497 18.0179L5.98206 18.6808ZM8.63372 18.6808L5.31916 15.3663L5.98206 14.7034L9.29663 18.0179L8.63372 18.6808ZM11.2854 18.6808L10.6225 18.0179L5.31916 12.7146L5.98206 12.0517L11.9483 18.0179L11.2854 18.6808ZM9.95956 14.7034L9.29666 14.0405L14.0308 9.30634L14.6937 9.96925L9.95956 14.7034ZM18.0083 11.958L12.042 5.99175L12.7049 5.32884L13.3678 5.99175L18.6711 11.2951L18.0083 11.958Z"
          fill="white"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.WORKOUT_CIRCLE) {
    return (
      <svg
        style={{ display: "block" }}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#DADCE3" />
        <path
          d="M22.6712 11.3176L24 9.99175L22.0083 8L20.6824 9.32884L19.3566 8L18.0308 9.32884L16.705 8L14.7162 9.99175L17.3679 12.6434L12.6337 17.3775L9.98206 14.7259L8 16.7146L9.31916 18.0404L8 19.3663L9.31916 20.6921L8 22.0179L9.98206 24L11.3079 22.6808L12.6337 24L13.9595 22.6808L15.2854 24L17.2741 22.0179L14.6225 19.3663L19.3566 14.6321L22.0083 17.2838L24 15.2951L22.6712 13.9692L24 12.6434L22.6712 11.3176ZM22.0083 9.32884L22.6712 9.99175L22.0083 10.6547L21.3453 9.99175L22.0083 9.32884ZM18.6937 9.99175L19.3566 9.32884L22.6712 12.6434L22.0083 13.3063L18.6937 9.99175ZM9.98206 22.6808L9.31916 22.0179L9.98206 21.355L10.645 22.0179L9.98206 22.6808ZM12.6337 22.6808L9.31916 19.3663L9.98206 18.7034L13.2966 22.0179L12.6337 22.6808ZM15.2854 22.6808L14.6225 22.0179L9.31916 16.7146L9.98206 16.0517L15.9483 22.0179L15.2854 22.6808ZM13.9596 18.7034L13.2967 18.0405L18.0308 13.3063L18.6937 13.9693L13.9596 18.7034ZM22.0083 15.958L16.042 9.99175L16.7049 9.32884L17.3678 9.99175L22.6711 15.2951L22.0083 15.958Z"
          fill="#01052F"
        />
      </svg>
    );
  }
  if (type === CalendarIconType.NUTRITION) {
    return (
      <svg
        style={{ display: "block" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="#36890F" />
        <g clipPath="url(#clip0)">
          <path
            d="M16.219 10.1249C16.018 10.1249 15.8181 10.1441 15.62 10.1818C15.8463 9.80784 16.1757 9.49877 16.5771 9.29812L16.8973 9.13798L16.4781 8.2995L16.1578 8.45965C15.3842 8.84646 14.801 9.52098 14.5235 10.3245C14.1581 10.192 13.7842 10.1249 13.4067 10.1249C13.2907 10.1249 13.1761 10.1312 13.0628 10.1428L13.439 4.50024H4L4.99994 19.493C5.03121 19.493 11.9594 19.493 12 19.4931L12.0005 19.0691C12.4467 19.3512 12.922 19.4993 13.4067 19.4993C13.8846 19.4993 14.3565 19.3922 14.8129 19.1805C15.2692 19.3922 15.7411 19.4993 16.219 19.4993C18.3135 19.4993 20 16.6787 20 14.3434C20 12.0173 18.3039 10.1249 16.219 10.1249ZM9.65692 14.3434C9.65692 15.0999 9.83534 15.9237 10.1526 16.687H5.75195L5.16896 7.94177L5.419 7.73625C6.28126 7.02755 7.53293 7.02755 8.39519 7.73625L9.38597 8.55058C9.98383 9.04198 10.7254 9.29584 11.4726 9.29581C11.711 9.29581 11.9499 9.26975 12.1849 9.21753L12.107 10.3863C10.6781 10.9822 9.65692 12.5311 9.65692 14.3434ZM12.437 5.43771L12.2511 8.22535C11.4847 8.49608 10.6186 8.35025 9.98121 7.82637L8.99043 7.01205C7.87044 6.09152 6.28148 6.02565 5.09371 6.81322L5.002 5.43771H12.437ZM5.81445 17.6244H10.6334C10.6532 17.6562 10.6734 17.6878 10.6937 17.7191C10.9034 18.0416 11.1303 18.3234 11.3703 18.5619L5.87691 18.5619L5.81445 17.6244ZM18.1633 17.2057C17.5953 18.0676 16.8867 18.5619 16.219 18.5619C15.5764 18.5619 15.1383 18.2995 14.8128 18.1219C14.5163 18.2837 14.0653 18.5619 13.4067 18.5619C11.9185 18.5619 10.5944 16.2029 10.5944 14.3434C10.5944 12.5342 11.856 11.0624 13.4067 11.0624C14.0493 11.0624 14.4873 11.3247 14.8128 11.5023C15.1094 11.3405 15.5603 11.0624 16.219 11.0624C17.787 11.0624 19.0626 12.5342 19.0626 14.3434C19.0626 15.2671 18.718 16.3639 18.1633 17.2057Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return null;
};

export default CalendarIcons;
